import { defineMessages } from 'react-intl';

export default defineMessages({
  note: {
    id: 'landingmozza.hero.searchbar.note',
    defaultMessage: '<bb>Note 4,9 | {reviewsCount}</bb> avis',
  },
});
